/*首页功能相关路由*/
const TwoDMapMain = () =>  import("../../studio/twoDMap/two_d_map_main");

export default [
  {
    path: '/TwoDMapMain',
    name: '二维地图',
    component: TwoDMapMain
  }
]



// WEBPACK FOOTER //
// ./src/router/modules/two_d_map_page.js